<template>
  <div class="about-container">
    <!-- 顶部标题 -->
    <div class="page-header">
      <p class="subtitle">{{ pageData.subtitle || '品质 · 效率 · 服务' }}</p>
    </div>

    <!-- 主要内容区域 - 左右结构 -->
    <el-row :gutter="30" class="main-content">
      <!-- 左侧图片 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" class="image-col">
        <el-image
            class="about-image"
            :src="pageData.imageUrl || require('@/assets/logo/1752137905335.jpg')"
            fit="cover"
            alt="格里弗光电科技"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
            <span>公司形象图片</span>
          </div>
        </el-image>
      </el-col>

      <!-- 右侧内容 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" class="content-col">
        <div class="about-content">
          <h2>{{ pageData.companyName || '格里弗（成都）光电科技有限公司' }}</h2>

          <div class="company-info">
            <p><strong>成立时间：</strong>{{ pageData.established}}</p>
            <p><strong>企业定位：</strong>{{ pageData.positioning}}</p>
            <p><strong>企业观念：</strong>{{ pageData.positioningguanliang}}</p>
          </div>
          <div v-html="pageData.content || defaultContent"></div>
        </div>
      </el-col>
    </el-row>

    <!-- 新增的图文感恩板块 -->
    <div class="grateful-section">
      <el-row :gutter="30" class="grateful-content">
        <!-- 左侧文字内容 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12" class="text-col">

            <h3 class="section-subtitle">以感恩之心，创视界之巅，铸音视频之魂</h3>
            <h2 class="section-title">/grateful/感谢的，感激不尽的，受欢迎的</h2>
            <div class="section-text">
              <p><strong>以感恩之心:</strong>感恩客户信任，感谢员工付出，感恩合作伙伴支持，感谢社会赋予的发展机遇。</p>
              <p><strong>创视界之巅:</strong>用先进的LED显示技术和音视频系统，为客户呈现清晰、震撼的视觉体验，引领显示技术潮流。</p>
              <p><strong>铸音视频之魂:</strong>专注于音频系统及音视频系统集成，以专业的技术和优质的服务，为客户打造卓越的音视频体验。以智慧信息化建设为契机，助力信息化发展，用科技赋能，传递知识，合迪智慧。</p>
            </div>

        </el-col>

        <!-- 右侧图片 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12" class="image-col">
          <el-image
              class="grateful-image"
              :src="require('@/assets/aa/20210122174801.jpg')"
              fit="cover"
              alt="感恩图片"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
              <span>感恩图片</span>
            </div>
            <div class="image-overlay"></div>
          </el-image>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutGreef',
  data() {
    return {
      activeCollapse: ['business'],
      pageData: {
        title: '关于我们',
        subtitle: '品质 · 效率 · 服务',
        companyName: '格里弗（成都）光电科技有限公司',
        established: '2021年3月',
        positioning: '音响设备销售，显示器件销售，光电子器件销售，电子元器件零售，光通信设备销售，人工智能行业应用系统集成服务，电子产品销售，市政设施管理，计算机系统服务，计算机软硬件及辅助设备零售，数字视频监控系统销售，云计算装备技术服务，教学专用仪器销售，信息系统集成服务，电力电子元器件销售，办公设备销售，机械设备租赁，会议及展览服务，网络设备销售，信息安全设备销售，信息技术咨询服务',
        positioningguanliang:'       公司技术力量雄厚，人才济济，实践经验丰富，组织协调能力一流，具有良好的默契和团队意识。公司自创建以来，始终坚持“品质、效率、服务”6字理念，以“产品品质为生命、以时间效率为目标、以售后服务为信誉”作为公司的经营理念，在实践中提升整体能力、增强竞争实力、不断打造优质项目。',
        imageUrl: '',
      },
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      setTimeout(() => {
        const savedData = localStorage.getItem('greefAboutData');
        if (savedData) {
          this.pageData = JSON.parse(savedData);
        }
      }, 300);
    }
  }
}
</script>

<style scoped>
.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  text-align: center;
  margin-bottom: 100px;
}

.subtitle {
  font-size: 1.2rem;
  color: #666;
  letter-spacing: 1px;
}

.main-content {
  margin-bottom: 50px;
}

.image-col, .content-col {
  margin-bottom: 30px;
}

.about-image {
  width: 100%;
  height: 450px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
}

.image-slot {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

.image-slot span {
  font-size: 16px;
  margin-top: 10px;
}

.about-content {
  padding: 0 15px;
}

.about-content h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.8rem;
  font-weight: bold;
  border-left: 4px solid #409EFF;
  padding-left: 15px;
}

.company-info {
  margin-bottom: 25px;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 4px;
}

.company-info p {
  margin-bottom: 10px;
  line-height: 1.6;
  color: #555;
}

.about-content >>> p {
  margin-bottom: 15px;
  line-height: 1.8;
  color: #555;
  text-align: justify;
}

/* 新增感恩板块样式 */
.grateful-section {
  margin: 80px 0;
  background: linear-gradient(135deg, #f9f9f9, #f0f7ff);
  padding: 40px;
  border-radius: 12px;
}

.grateful-content {
  display: flex;
  align-items: center;
}

.text-content {
  padding-right: 40px;
}

.section-title {
  font-size: 1.6rem;
  color: #409EFF;
  margin-bottom: 10px;
  font-weight: 400;
  letter-spacing: 1px;
}

.section-subtitle {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 30px;
  font-weight: 500;
  position: relative;
  padding-bottom: 15px;
}

.section-subtitle::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 80px;
  height: 3px;
  background: linear-gradient(to right, #409EFF, #67C23A);
}

.section-text p {
  margin-bottom: 20px;
  line-height: 1.8;
  color: #555;
  text-align: justify;
}

.section-text strong {
  color: #333;
  font-weight: 500;
}

.grateful-image {
  width: 100%;
  height: 400px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  transition: transform 0.3s;
}

.grateful-image:hover {
  transform: translateY(-5px);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent 30%);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .grateful-section {
    padding: 30px;
  }

  .text-content {
    padding-right: 30px;
  }
}

@media (max-width: 992px) {
  .grateful-content {
    flex-direction: column;
  }

  .text-content {
    padding-right: 0;
    padding-bottom: 30px;
  }

  .grateful-image {
    height: 350px;
  }
}

@media (max-width: 768px) {
  .grateful-section {
    margin: 60px 0;
    padding: 25px;
  }

  .section-title {
    font-size: 1.4rem;
  }

  .section-subtitle {
    font-size: 1.5rem;
    margin-bottom: 25px;
  }

  .grateful-image {
    height: 300px;
  }
}

@media (max-width: 576px) {
  .grateful-section {
    margin: 50px 0;
    padding: 20px;
  }

  .section-title {
    font-size: 1.3rem;
  }

  .section-subtitle {
    font-size: 1.3rem;
    padding-bottom: 10px;
  }

  .grateful-image {
    height: 250px;
  }
}
strong{
  font-weight: bold;
  font-size: 18px;
}
</style>
